<template>
  <div ref="container">
    <div class="searchGood">
      <div class="search acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo2"></span>
          <form @submit.prevent>
            <input type="search" :placeholder="`点击搜索${searchText}`" v-model="search" @keydown.enter="submit"/>
          </form>
        </div>
        <div class="bnt" @click="submit">搜索</div>
      </div>
      <div v-if="keywords.length">
        <div class="title">热门搜索</div>
        <div class="list acea-row">
          <div
            class="item"
            v-for="key of keywords"
            :key="key"
            @click="toSearch(key)"
          >
            {{ key }}
          </div>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <GoodList :goodList="goodList" 
        :isSort="false" 
        :isShowShopCart="false" 
        :isShowSale="isShowSale"
        :isPrice="isPrice"
        :isAuthor="isAuthor"
        :bottomBoxStyle="bottomBoxStyle"
        :boxStyle="boxStyle"
        ></GoodList>
      <Loading
        :loaded="loadend"
        :loading="loading"
        v-if="goodList.length"
      ></Loading>
    </div>
    <div
      class="noCommodity"
      v-cloak
      v-if="goodList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noSearch.png" class="image" />
      </div>
      <recommend :type="where.type"></recommend>
    </div>
  </div>
</template>
<script>
import Loading from "@components/Loading";
import GoodList from "@components/GoodList";
import { getSearchKeyword } from "@api/store";
import { trim } from "@utils";
import { getProducts } from "@api/store";
import Recommend from "@components/Recommend";
let searchBook = 1;// 1=商品；2=图书；
export default {
  name: "GoodSearch",
  components: {
    GoodList,
    Loading,
    Recommend
    // Recommend,
    // GoodList
  },
  props: {},
  data: function() {
    return {
      searchText: searchBook === 2 ? "图书":"商品",
      isShowShopCart: searchBook === 2 ? false : true,
      isShowSale: searchBook === 2 ? false : true,
      isPrice: searchBook === 2 ? false : true,
      isAuthor: searchBook === 2 ? true : false,
      bottomBoxStyle: searchBook === 2 ? {"padding-bottom":"0"}:{},
      boxStyle: searchBook === 2 ? {"height": "3.8rem","border-radius": "0.2rem"}:{},
      keywords: [],
      search: "",
      where: {
        page: 1,
        limit: 20,
        keyword: "",
        type: searchBook
      },
      loading: false,
      loadend: false,
      goodList: []
    };
  },
  mounted: function() {
    this.getData();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getGoodlist();
    });
  },
  beforeRouteEnter: function (to, from, next) {
    if (to.name === "bookSearch") {
      searchBook = 2;
    } else {
      searchBook = 1;
    }
    next();
  },
  methods: {
    submit() {
      const search = trim(this.search) || "";
      if (!search) return;
      this.where.keyword = search;
      this.$set(this, "goodList", []);
      this.where.page = 1;
      this.where.type = searchBook;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    // toSearch(s) {
    //   this.$router.push({ path: "/goods_list", query: { s } });
    // },
    getData() {
      getSearchKeyword().then(res => {
        let data = res && res.data;
        let key = [];
        data.forEach((val)=>{
            if (searchBook === 2 && val.type == '2') {
              key.push(val.title);
            } else if (searchBook === 1 && (!val.type || val.type == '1') ){
              key.push(val.title);
            }
        });
        this.keywords = key;
      });
    },
    toSearch: function(key) {
      this.search = key;
      this.where.keyword = key;
      this.$set(this, "goodList", []);
      this.where.page = 1;
      this.where.type = searchBook;
      this.loadend = false;
      this.loading = false;
      this.getGoodlist();
    },
    getGoodlist: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = that.where;
      getProducts(q).then(res => {
        that.loading = false;
        that.goodList.push.apply(that.goodList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 0.05rem solid #f5f5f5;
}
</style>
